import { render, staticRenderFns } from "./SCardContent.vue?vue&type=template&id=ea7372e0&scoped=true&"
var script = {}
import style0 from "./SCardContent.vue?vue&type=style&index=0&id=ea7372e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7372e0",
  null
  
)

export default component.exports